export const queryKeys = {
  SUMMARY_INSIGHT_DAILY: 'SUMMARY_INSIGHT_DAILY',
  SUMMARY_INSIGHT_ADMIN: 'SUMMARY_INSIGHT_ADMIN',
  SUMMARY_INSIGHT_WITH_DATE: 'SUMMARY_INSIGHT_WITH_DATE',
  SUMMARY_INSIGHT_WITH_DATE_RESULT: 'SUMMARY_INSIGHT_WITH_DATE_RESULT',
  SUMMARY_INSIGHT_LEADERBOARD_INFINITY: 'SUMMARY_INSIGHT_LEADERBOARD_INFINITY'
};
